<div class="l-top-guidance" [ngClass]="{ 'l-top-guidance--attention': isWarning, 'l-top-guidance--error': isError }">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-guidance__inner">
        <p class="l-top-guidance__message">
          <em class="l-top-guidance__text">
            <div [innerHTML]="(dispContent | staticMsg : item.interpolateParams || []) + (item.displayKey || '')"></div>
          </em>
        </p>
        <div *ngIf="item.isCloseEnable">
          <button id="alert-button1" class="l-top-guidance__close" (click)="clickClose()">
            <span class="u-visually-hidden" [innerHTML]="'label.close' | staticMsg"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
